'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _MainContent = require('./components/MainContent.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_MainContent).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-drawer/lib/components/main-content/index.js
// module id = 1064
// module chunks = 1